import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";
import { SITE } from "@/config/site";
import { Reveal } from "./motion";
import { CtaButton } from "./CtaButton";
import { Logo } from "./Logo";

export const FinalCta = () => (
  <section className="relative overflow-hidden bg-night pb-28 pt-20 text-white sm:py-28" data-testid="final-cta-section">
    <div className="pointer-events-none absolute left-1/2 top-0 h-[480px] w-[780px] -translate-x-1/2 rounded-full bg-rose/30 blur-[140px]" />
    <div className="relative mx-auto max-w-4xl px-5 text-center">
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.98] tracking-tight sm:text-6xl">
          Seu catálogo de <span className="text-sun">+25.000 produtos</span> pronto para vender
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base text-zinc-300 sm:text-lg">Enquanto outras pessoas passam semanas criando um produto, você pode começar hoje com materiais prontos, kits para revenda e 3 bônus para divulgar.</p>
        <CtaButton target="planos" testId="final-cta-button" className="mt-9">Quero o Premium + 3 bônus</CtaButton>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-zinc-300">
          {["Pagamento único", "Acesso imediato", "Garantia de 7 dias"].map((t) => <span key={t} className="flex items-center gap-1.5"><Check className="h-4 w-4 text-sun" />{t}</span>)}
        </div>
      </Reveal>
      <div className="mt-20 flex flex-col items-center gap-3 border-t border-white/10 pt-10">
        <Logo light />
        <p className="text-xs text-zinc-400">© {new Date().getFullYear()} {SITE.name}. Todos os direitos reservados.</p>
      </div>
    </div>
  </section>
);

export const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const plans = document.getElementById("planos")?.getBoundingClientRect();
      const inPlans = plans && plans.top < window.innerHeight && plans.bottom > 0;
      setShow(window.scrollY > 700 && !inPlans);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 120 }} animate={{ y: 0 }} exit={{ y: 120 }} transition={{ type: "spring", stiffness: 260, damping: 26 }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-ink/10 bg-white/85 p-3 backdrop-blur-xl md:hidden" data-testid="sticky-mobile-cta">
          <CtaButton target="planos" testId="sticky-mobile-cta-button" className="w-full !py-3.5 !text-sm">Quero começar agora</CtaButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
